<template>
    <div id="app-sidebar" class="menu-wrapper"
        :class="['menu-theme-' + menuTheme, { 'layout-sidebar-active': layoutMode === 'sidebar' && sidebarStatic }]"
        @click="onMenuClick">
        <div class="sidebar-logo">
            <router-link to="/">
                <img src="layout/images/logo-payment-hub.png" width="17" height="20" alt="Payment Hub">
            </router-link>
        </div>

        <div class="layout-menu-container">
            <div class="menu-navigation">
                <AppSubmenu class="layout-menu" :items="menu" :layoutMode="layoutMode" :parentMenuItemActive="true"
                    :menuActive="menuActive" :mobileMenuActive="mobileMenuActive" :root="true"
                    @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick" />
            </div>

            <div ref="accountMenu" class="account-menu" @click.stop @focusout="onAccountFocusOut"
                @keydown.esc.stop="onAccountMenuEscape">
                <button ref="accountTrigger" type="button" class="account-trigger" aria-controls="account-options"
                    :aria-expanded="accountMenuOpen"
                    :aria-label="`${accountMenuOpen ? 'Fechar' : 'Abrir'} opções da conta de ${userName}`"
                    @click="toggleAccountMenu">
                    <span class="account-avatar" aria-hidden="true">{{ userInitial }}</span>
                    <span class="account-trigger-copy">
                        <span class="account-name">{{ userName }}</span>
                    </span>
                    <i class="pi account-chevron" :class="accountMenuOpen ? 'pi-angle-down' : 'pi-angle-up'"
                        aria-hidden="true"></i>
                </button>

                <transition name="account-popover">
                    <div v-if="accountMenuOpen" id="account-options" class="account-popover" role="group"
                        aria-label="Opções da conta">
                        <div class="account-summary">
                            <span class="account-avatar account-summary-avatar" aria-hidden="true">{{ userInitial }}</span>
                            <span class="account-summary-copy">
                                <strong class="account-name">{{ userName }}</strong>
                                <span v-if="userLogin" class="account-login">{{ userLogin }}</span>
                            </span>
                        </div>

                        <div class="account-actions">
                            <button type="button" class="account-action" @click="onMyAccount">
                                <i class="pi pi-user" aria-hidden="true"></i>
                                <span>Minha conta</span>
                            </button>
                            <button type="button" class="account-action" @click="onLogout">
                                <i class="pi pi-sign-out" aria-hidden="true"></i>
                                <span>Sair</span>
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu"
export default {
    name: "AppMenu",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click", "my-account", "logout"],
    props: {
        sidebarStatic: Boolean,
        layoutMode: String,
        menuTheme: String,
        menuActive: Boolean,
        mobileMenuActive: Boolean,
        currentUser: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            accountMenuOpen: false,
            menu: [
                { label: "Dashboard", icon: "pi pi-home", to: "/" },
                { label: "Usuários", icon: "pi pi-users", to: "/users" },
                { label: "Fornecedores", icon: "pi pi-dollar", to: "/vendors" },
                { label: "Saldo de Fornecedores", icon: "pi pi-wallet", to: "/vendor-balances" },
                { label: "Clientes", icon: "pi pi-server", to: "/clients" },
                { label: "Transações", icon: "pi pi-sort-alt", to: "/transactions" },
                { label: "Transação Manual", icon: "pi pi-sync", to: "/manual-transaction" },
            ]
        }
    },
    computed: {
        userName() {
            const name = this.currentUser?.name || this.currentUser?.login || "Usuário"
            return String(name).trim() || "Usuário"
        },
        userLogin() {
            return String(this.currentUser?.login || "").trim()
        },
        userInitial() {
            return Array.from(this.userName)[0]?.toLocaleUpperCase("pt-BR") || "U"
        }
    },
    mounted() {
        document.addEventListener("click", this.closeAccountMenu)
    },
    beforeUnmount() {
        document.removeEventListener("click", this.closeAccountMenu)
    },
    methods: {
        onMenuClick(event) {
            this.$emit("menu-click", event)
        },
        onMenuItemClick(event) {
            this.closeAccountMenu()
            this.$emit("menuitem-click", event)
        },
        onRootMenuItemClick(event) {
            this.$emit("root-menuitem-click", event)
        },
        toggleAccountMenu() {
            this.accountMenuOpen = !this.accountMenuOpen
        },
        closeAccountMenu() {
            this.accountMenuOpen = false
        },
        onAccountFocusOut(event) {
            if (!this.$refs.accountMenu?.contains(event.relatedTarget)) {
                this.closeAccountMenu()
            }
        },
        onAccountMenuEscape() {
            this.closeAccountMenu()
            this.$nextTick(() => this.$refs.accountTrigger?.focus())
        },
        onMyAccount() {
            this.closeAccountMenu()
            this.$emit("my-account")
        },
        onLogout() {
            this.closeAccountMenu()
            this.$emit("logout")
        }
    },
    components: { AppSubmenu },
}
</script>

